import { render, staticRenderFns } from "./GuppyChatPrivateList.vue?vue&type=template&id=1ca06bf9&"
import script from "./GuppyChatPrivateList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatPrivateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports